import {createSlice, isAnyOf} from '@reduxjs/toolkit';
import {
  clearDeskBookingStatus,
  clearDesks,
  clearDeskSuggestions,
  clearSuggestionError,
  loadDeskBookingStatus,
  loadDesks,
  loadDesksByAreaId,
  loadDeskSuggestions,
  loadDeskSuggestionsAndData,
  suggestionErrorSet,
  resetSuggestedDesk,
} from './actions';
import {desksAdapter, suggestedDesksAdapter} from './adapters';
import {initialState} from './initialState';

const slice = createSlice({
  name: 'desks',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadDesks.pending, (state) => {
        state.list.isLoading = true;
      })
      .addCase(loadDesks.fulfilled, (state, action) => {
        desksAdapter.upsertMany(state.list, action.payload ?? []);
        state.list.isLoading = false;
      })
      .addCase(loadDesks.rejected, (state) => {
        state.list.isLoading = false;
      })
      .addCase(loadDeskSuggestions.pending, (state) => {
        state.suggestedDesks.isLoading = true;
      })
      .addCase(loadDeskSuggestions.fulfilled, (state, action) => {
        suggestedDesksAdapter.setAll(state.suggestedDesks, action.payload.suggestedDesks ?? {});
        state.suggestedDesks.isLoading = false;
      })
      .addCase(loadDeskSuggestions.rejected, (state) => {
        state.suggestedDesks.isLoading = false;
      })
      .addCase(clearDeskSuggestions, (state) => {
        suggestedDesksAdapter.removeAll(state.suggestedDesks);
      })
      .addCase(loadDeskBookingStatus.pending, (state) => {
        state.deskBookingStatus.isLoading = true;
      })
      .addCase(loadDeskBookingStatus.fulfilled, (state, action) => {
        state.deskBookingStatus.isLoading = false;
        state.deskBookingStatus.entities = action.payload;
      })
      .addCase(loadDeskBookingStatus.rejected, (state) => {
        state.deskBookingStatus.isLoading = false;
      })
      .addCase(clearDeskBookingStatus, (state) => {
        state.deskBookingStatus.entities = {};
      })
      .addCase(clearDesks, (state) => {
        desksAdapter.removeAll(state.list);
      })
      .addCase(clearSuggestionError, (state) => {
        state.suggestionError = undefined;
      })
      .addCase(suggestionErrorSet, (state, action) => {
        state.suggestionError = action.payload;
      })
      .addCase(resetSuggestedDesk, (state) => {
        state.suggestedDeskIds = [];
      })
      .addCase(loadDesksByAreaId.pending, (state) => {
        state.isLoadingDeskByAreaId = true;
      })
      .addCase(loadDeskSuggestionsAndData.pending, (state) => {
        state.isLoadingDeskSuggestions = true;
      })
      .addCase(loadDeskSuggestionsAndData.fulfilled, (state, action) => {
        const suggestedDeskIds = action.payload;
        state.suggestedDeskIds = suggestedDeskIds;
        state.isLoadingDeskSuggestions = false;
      })
      .addCase(loadDeskSuggestionsAndData.rejected, (state) => {
        state.isLoadingDeskSuggestions = false;
      })
      .addMatcher(isAnyOf(loadDesksByAreaId.fulfilled, loadDesksByAreaId.rejected), (state) => {
        state.isLoadingDeskByAreaId = false;
      });
  },
});

export const {reducer: desksReducer} = slice;
